export const FETCH_ALL_DISTRICTS = 'FETCH_ALL_DISTRICTS';
export const GET_DISTRICT = 'GET_DISTRICT';
export const CREATE_DISTRICT = 'CREATE_DISTRICT';
export const UPDATE_DISTRICT = 'UPDATE_DISTRICT';
export const DELETE_DISTRICT = 'DELETE_DISTRICT';